// =========================================================
// Custom Theme Layout — JavaScript
// Extracted from layout/theme.liquid
// =========================================================

// §1: /collections/all → Redirect to homepage
if (window.location.pathname === '/collections') {
  window.location.href = '/';
}

// §2: Add body class on collections pages
if (window.location.pathname.startsWith('/collections/')) {
  document.body.classList.add('on-collections-page');
}

// §3: Cart drawer open handler
document.addEventListener('DOMContentLoaded', function () {
  const cartButton = document.getElementById('cart-icon-bubble');
  const cartDrawer = document.querySelector('cart-drawer');

  if (cartButton && cartDrawer) {
    cartButton.addEventListener('click', function (e) {
      e.preventDefault();
      cartDrawer.open(cartButton);
    });
  }
});

// §4: Sticky Add-to-Cart bar trigger (product pages only)
document.addEventListener("DOMContentLoaded", function() {
  const stickyBtn = document.getElementById('sticky-atc-trigger');
  
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const mainBuyButton = document.querySelector('.product-form__submit');
      
      if (mainBuyButton) {
        mainBuyButton.click();
        
        // Feedback visual: Cambio de COLOR a #8f2626
        stickyBtn.style.backgroundColor = '#8f2626';
        
        setTimeout(() => {
            stickyBtn.style.backgroundColor = '#780f0f'; 
        }, 2000);
        
      } else {
        console.error('No se encontró el botón principal de compra');
      }
    });
  }
});

// =========================================================================
// LÓGICA DE RECARGA FORZADA A PUNTO 0 CON DESPLAZAMIENTO SUAVE
// =========================================================================
(function() {
  // 1. Detectar mediante la API de rendimiento si el tipo de navegación es una recarga (Reload)
  const navigationEntries = window.performance && window.performance.getEntriesByType('navigation');
  const isReload = navigationEntries && navigationEntries[0] && navigationEntries[0].type === 'reload';

  if (isReload) {
    // 2. Apagar la restauración automática del scroll del navegador de inmediato
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // 3. Recuperar la posición guardada antes de la recarga
    const savedScrollPosition = sessionStorage.getItem('theme-reload-position');
    
    if (savedScrollPosition && parseInt(savedScrollPosition, 10) > 0) {
      // 4. Forzar al navegador a renderizar el inicio de la web arriba del todo (Punto 0)
      window.scrollTo(0, 0);

      // 5. Esperar al evento 'load' para asegurar que el DOM, imágenes y el layout estén calculados
      window.addEventListener('load', function() {
        // Pequeño margen de tiempo (100ms) para que scripts externos de Shopify no interrumpan
        setTimeout(function() {
          window.scrollTo({
            top: parseInt(savedScrollPosition, 10),
            behavior: 'smooth'
          });

          // 6. Devolver el control nativo de scroll al navegador una vez termine la animación
          setTimeout(function() {
            if ('scrollRestoration' in history) {
              history.scrollRestoration = 'auto';
            }
          }, 1200); // Tiempo estimado que dura el desplazamiento suave
        }, 100);
      });
    }
  }

  // Guardar la posición exacta del scroll del usuario justo antes de que la página se desmonte/recargue
  const saveCurrentScroll = function() {
    sessionStorage.setItem('theme-reload-position', window.scrollY);
  };

  window.addEventListener('beforeunload', saveCurrentScroll);
  window.addEventListener('pagehide', saveCurrentScroll);
})();